var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAddress(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:none;stroke:#fdfdfd;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-width:1.2px;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(3.886 2.511)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M0,7.015a7.038,7.038,0,1,1,14.077.048v.08a10.394,10.394,0,0,1-3.188,6.688A18.5,18.5,0,0,1,7.6,16.54a.853.853,0,0,1-1.116,0A18.166,18.166,0,0,1,1.849,12.2,9.007,9.007,0,0,1,0,7.038Z",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "a",
    cx: 2.256,
    cy: 2.256,
    r: 2.256,
    transform: "translate(4.783 4.894)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddress);
export default __webpack_public_path__ + "static/media/address.74f3f67ae324967d390e600ddf19c614.svg";
export { ForwardRef as ReactComponent };